import { Box, LinearProgress, Stack } from "@mui/material";
import { ReactComponent as Bell } from "assets/Bell.svg";
import { librarySelectedTab } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { triggerOnboadingWizard } from "components/features/Onboarding/Helper";
import FocusAreas from "components/features/library/SuggestedPlans/FocusAreas";
import { useTranslate } from "hooks/useTranslate";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { getUserName } from "utils/StoreUtils";
import { pageNames } from "utils/Types";
import Button from "./Button";
import "./NoPlansBanner.scss";
import Typography from "./Typography";
import { noPlansMessage } from "./plans/NoPlansMessageConfig";
import { noPlansMessageCorpUser } from "./plans/NoPlansMessageCorpConfig";

interface Props {
  isDashboard?: boolean;
  pageName?: number;
  height?: string;
  backgroundPositionY?: string;
  onClickHandle?: () => void;
  type?: number;
  buttons?: any;
  showNoSuggestedBanner?: boolean;
  minHeight?: string;
  maxHeight?: string;
}
function NoPlansBanner(props: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    pageName: pageNameProp,
    onClickHandle,
    isDashboard,
    height,
    type,
    buttons,
    showNoSuggestedBanner = false,
    minHeight,
    maxHeight
  } = props;

  const { selectedTab, searchActive } = useAppSelector((state: any) => state.app);
  const { isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const pageName = searchActive ? type ?? pageNames.searchResult : pageNameProp;
  const { title, content, showButton, buttonLabel } =
    isCorp || isAbovePropertyUser
      ? noPlansMessageCorpUser[pageName ?? (selectedTab || 0)]
      : noPlansMessage[pageName ?? (selectedTab || 0)];
  let { isMobileScreen } = useContext(ThemeContext);
  isMobileScreen = isMobileScreen || !!isDashboard;
  const newAreaOfFocusesAvailable: any = useAppSelector((state) => state.suggestedPlans.newAreaOfFocusesAvailable);
  const translate = useTranslate();
  const selectedFocusAreas: string[] = useAppSelector((state) => state.suggestedPlans.selectedFocusAreas);
  const focusAreasCheck = showNoSuggestedBanner;

  const customButtons = (
    <Button
      sx={{ width: isMobileScreen ? "100%" : "auto" }}
      accessType={accessTypes.delete}
      size={isDashboard ? "Small" : "Medium"}
      variant="primaryWhite"
      label={"Retake the Wizard"}
      onClick={() => {
        triggerOnboadingWizard(dispatch);
      }}
    />
  );
  const focusedAreaText = isMobileScreen
    ? translate("dashboard.focusedArea.flagTrue.mobile")
    : translate("dashboard.focusedArea.flagTrue.desktop");

  const getFocusAreaData = () => {
    return <FocusAreas />;
  };
  const heightValue = minHeight ? { minHeight: minHeight } : { height: height ?? "202px" };

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        backgroundColor: tokens.Background.General.LightColor,
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        maxHeight: maxHeight ?? "auto",
        ...heightValue
      }}
    >
      <Stack
        flex="1"
        alignItems={isMobileScreen ? "center" : "flex-start"}
        sx={{
          padding: "32px",
          textAlign: isDashboard || isMobileScreen ? "center" : "left",
          zIndex: 1
        }}
        className="no-plan-banner-suggested-container"
      >
        <Typography
          variant={isDashboard || isMobileScreen ? "body1" : "h4"}
          showBold
          color={tokens.Text.General.Inverse}
        >
          {title}
          {pageName === pageNames.noAssignAction && `Welcome ${getUserName()}!`}
        </Typography>
        {content && !isDashboard && (
          <>
            {focusAreasCheck && selectedFocusAreas.length > 0 && getFocusAreaData()}
            <Typography variant="body1" color={tokens.Text.General.Inverse} sx={{ marginTop: "8px" }}>
              {content}
            </Typography>
            {focusAreasCheck && newAreaOfFocusesAvailable && (
              <div className="no-plan-banner-suggested-container">
                {" "}
                <div className="heading-wrapper">
                  <Bell />
                  <Typography showBold variant="body1" color={tokens.Icon.General.Inverse} children={focusedAreaText} />
                  <Bell />
                </div>
              </div>
            )}
          </>
        )}

        {pageName === pageNames.noActivePlans && (
          <LinearProgress variant="determinate" sx={{ width: "50%", marginTop: "10px" }} color="secondary" />
        )}
        {showButton && (
          <Stack
            direction={isDashboard ? "column" : "row"}
            spacing={2}
            alignItems="center"
            sx={{ marginTop: "32px" }}
            width={showNoSuggestedBanner ? "100%" : "auto"}
          >
            {showNoSuggestedBanner || isDashboard ? (
              buttons || customButtons
            ) : (
              <Button
                size={isDashboard ? "Small" : "Medium"}
                variant="primaryWhite"
                label={buttonLabel}
                onClick={() => {
                  if (onClickHandle) {
                    onClickHandle();
                  } else {
                    dispatch(librarySelectedTab(pageNames.allPlans));
                    navigate(`/library`);
                  }
                }}
              />
            )}
          </Stack>
        )}
      </Stack>

      {(isMobileScreen || isDashboard) && (
        <Stack
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            height: "100%"
          }}
        >
          {/* <Box component="img" src={image} alt="illustration" sx={{ height: "100%", objectFit: "contain" }} /> */}
          <Box
            sx={{
              position: "absolute",
              height: "inherit",
              width: "100%",
              background: tokens.Background.General.LightColor
            }}
          />
        </Stack>
      )}

      {!isMobileScreen && (
        <Stack flex="0.6" sx={{ height: "inherit" }}>
          {/* <Box component="img" src={image} alt="illustration" sx={{ height: "inherit", objectFit: "contain" }} /> */}
        </Stack>
      )}
    </Stack>
  );
}

export default NoPlansBanner;
